import md5 from "md5";
import sha1 from "sha1";

export const encryptPassword = (p) => sha1(md5(p.toUpperCase()));
